import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home'
import Docs from '../views/Docs'
import Faq from '../views/Faq'
import Account from '../views/Account'
import Transaction from '../views/Transaction'
import Block from '../views/Block'
import BlocksOverview from '../views/BlocksOverview'
import Representatives from '../views/Representatives'
import Ticker from '../views/Ticker'
import Contract from '../views/Contract'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'is-active', // for router-link
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/faq',
      name: 'Faq',
      component: Faq
    },
    {
      path: '/docs',
      name: 'Docs',
      component: Docs
    },
    {
      path: '/account/:account',
      name: 'Account',
      component: Account
    },
    {
      path: '/tx/:hash',
      name: 'Transaction',
      component: Transaction
    },
    {
      path: '/block/:hash',
      name: 'Block',
      component: Block
    },
    {
      path: '/blocks',
      name: 'BlocksOverview',
      component: BlocksOverview
    },
    {
      path: 'representatives',
      name: 'Representatives',
      component: Representatives
    },
    {
      path: '/ticker',
      name: 'Ticker',
      component: Ticker
    },
    {
      path: '/contract/:hash',
      name: 'Contract',
      component: Contract
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js